import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import NavBar from "../../components/feature/NavBar";
import DiscoverFilters, { TypeOption, CategoryOption } from "../../components/feature/DiscoverFilters";
import Videos from "../../components/feature/Videos";
import Footer from "../../components/feature/Footer";
import { usePageMeta } from "../../hooks/usePageMeta";

export type { Entity, VideoThumbnail } from "../../types/cms";

const Dashboard: React.FC = () => {
  usePageMeta("The Motion Hub — Motion design inspiration from brands and studios");
  const [selectedType, setSelectedType] = useState<TypeOption>("Vidéos");
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCategory = (searchParams.get("category") as CategoryOption) || "All";

  const setSelectedCategory = (category: CategoryOption) => {
    const next = new URLSearchParams(searchParams);
    if (category === "All") next.delete("category");
    else next.set("category", category);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="min-h-screen bg-neutral-50 text-gray-800 md:px-20 px-8">
      <NavBar />
      <DiscoverFilters
        title="Discover"
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Videos selectedType={selectedType} selectedCategory={selectedCategory} />
      <Footer />
    </div>
  );
};

export default Dashboard;
